<template>
  <tabs persist-as="redirects" v-if="viewAllowed">
    <tab name="Redirects" :active="true">
      <RedirectsTable
        :override-filters="this.overrideFilters"
        :overrideGqlFilters="this.overrideGqlFilters"
        :status="this.status"
        :isSalesAdmin="isSalesAdmin"
      >
      </RedirectsTable
    ></tab>
    <tab name="Auto Abyssed"> <AbyssedRedirects></AbyssedRedirects></tab>
  </tabs>
</template>

<script>
import RedirectsTable from '@/views/Admin/Redirects/RedirectsTable.vue'
import AbyssedRedirects from '@/views/Admin/Redirects/AbyssedRedirects.vue'
import ME_QUERY from '@/graphql/User/MeQuery.gql'

export default {
  props: {
    isSalesAdmin: {
      type: Boolean,
      default: false
    },
    overrideFilters: {
      type: Object
    },
    overrideGqlFilters: {
      type: Object
    },
    status: {
      type: String
    }
  },
  components: {
    RedirectsTable,
    AbyssedRedirects
  },
  apollo: {
    me: {
      query: ME_QUERY,
      result({ data }) {
        if (data && data.me) {
          this.me = data.me
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    viewAllowed() {
      if (
        this.me &&
        this.me.roles &&
        this.me.roles.some(role => role.name !== 'sales-admin-level-1')
      ) {
        return true
      }

      return false
    }
  },
  methods: {},
  mounted() {},
  updated() {}
}
</script>
